import { CHUNK_SIZE_M } from "../simulation/constants";
import type { PoiState } from "../simulation/snapshot";
import type { ChunkData } from "./chunks";

let nextPoiId = 10_000;

export function resetPoiIds(start = 10_000): void {
  nextPoiId = start;
}

export function materializePois(chunks: readonly ChunkData[], existing: PoiState[]): PoiState[] {
  const known = new Set(existing.map((p) => `${Math.floor(p.x)},${Math.floor(p.y)},${p.kind}`));
  const merged = [...existing];
  for (const chunk of chunks) {
    for (const poi of chunk.pois) {
      const x = chunk.cx * CHUNK_SIZE_M + poi.localX;
      const y = chunk.cy * CHUNK_SIZE_M + poi.localY;
      const signature = `${Math.floor(x)},${Math.floor(y)},${poi.kind}`;
      if (known.has(signature)) continue;
      known.add(signature);
      merged.push({
        id: nextPoiId++,
        kind: poi.kind,
        x,
        y,
        biome: chunk.biome,
        cleared: false,
        radius: poi.radius,
      });
    }
  }
  return merged;
}
